export default function AccessSection({ title = null, subtitle = null, children }) {
    return (
        <div className="access-section">
            { title && <p className="access-section__title">{ title }</p> }
            { subtitle && <p className="access-section__subtitle" dangerouslySetInnerHTML={{ __html: subtitle }}></p> }
            { children }
        </div>
    )
}